export default __webpack_public_path__ + "static/media/electrician.7d56beea.png";